module.exports = __webpack_public_path__ + "img/1483337548.a93a9319.jpg";